require("core-js/modules/es.array.reduce.js");

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ParseTable = exports.validTable = void 0;

var react_1 = __importDefault(require("react"));

var self_1 = require("../elements/self");

var __1 = require("..");

var replaceTable = function replaceTable(children, wheel) {
  var rows = [];
  react_1.default.Children.forEach(children, function (child) {
    if (child && typeof child === 'string') {
      rows = child.split('\n').filter(function (row) {
        return row.length > 0;
      }).reduce(function (result, currentRow, index) {
        result.push(react_1.default.createElement(self_1.Tr, {
          key: index,
          wheel: wheel
        }, currentRow.split('|').filter(function (cell) {
          return cell.length > 0;
        }).map(function (cell, index) {
          return react_1.default.createElement(self_1.Td, {
            key: index,
            wheel: wheel
          }, cell);
        })));
        return result;
      }, []);
    } else if (child) {
      rows.push(child);
    }
  });
  return rows;
};

exports.validTable = function (children) {
  var childArray = react_1.default.Children.toArray(children);
  return childArray && Array.isArray(childArray) && childArray.length > 0 && typeof childArray[0] === 'string' && childArray[0][0] === '|';
};

exports.ParseTable = function (props) {
  return react_1.default.createElement(__1.Table, {
    wheel: props.wheel
  }, react_1.default.createElement("tbody", null, replaceTable(props.children, props.wheel)));
};